module.exports = __webpack_public_path__ + "media/images/icons/arrow_right_short-313f0eeaa7b736715be9dae1f2266170.svg";